

import { MapFilterPanel } from "@/components/map/map-filter-panel"
import { EnhancedMapCanvas } from "@/components/map/enhanced-leaflet-map"
import { MapLayersProvider } from "@/contexts/MapLayersContext"
import { MapInteractionProvider } from "@/contexts/MapInteractionContext"

export function MapExplorer() {
  return (
    <MapLayersProvider>
      <MapInteractionProvider>
        <MapExplorerContent />
      </MapInteractionProvider>
    </MapLayersProvider>
  )
}

function MapExplorerContent() {
  return (
    <div className="relative h-[calc(100vh-4rem)] overflow-hidden">
      {/* Left Filter Panel */}
      <div className="absolute left-0 top-0 bottom-0 z-[1000] h-full">
        <MapFilterPanel />
      </div>

      {/* Main content area */}
      <div className="flex h-full">
        {/* Central Map Area */}
        <div className="flex-1 relative">
          <EnhancedMapCanvas />
        </div>
      </div>
    </div>
  )
}
